// extracted by mini-css-extract-plugin
export const container = "Partner-module--container--oUPuT";
export const partnerHeadline = "Partner-module--partnerHeadline--3ZO4o";
export const partnerList = "Partner-module--partnerList--1UV53";
export const animationPartnerList = "Partner-module--animation-partner-list--328e0";
export const partnerNote = "Partner-module--partnerNote--31r0l";